import React, { useState } from 'react';
import { Link, useNavigate, Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import BrandName from '../components/BrandName';
import './Auth.css';

const isSafeRedirect = (path: string | null): path is string =>
  !!path && path.startsWith('/') && !path.startsWith('//');

const Login: React.FC = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const redirectToParam = searchParams.get('redirectTo');
  const redirectTo = isSafeRedirect(redirectToParam) ? redirectToParam : '/machines';
  // Ustawiane przez interceptor axios po 401 na wygasłej sesji (patrz api/client.ts).
  const sessionExpired = searchParams.get('expired') === '1';

  if (user) return <Navigate to={redirectTo} replace />;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      navigate(redirectTo);
    } catch (err: any) {
      const status = err?.response?.status;
      if (status === 403) {
        setError(err?.response?.data?.message || 'Konto oczekuje na zatwierdzenie przez administratora');
      } else {
        setError('Nieprawidłowy e-mail lub hasło');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <form className="auth-card" onSubmit={handleSubmit}>
        <h1 className="auth-title"><BrandName /></h1>
        <p className="auth-subtitle">Zaloguj się do systemu</p>

        {sessionExpired && !error && (
          <div className="auth-info">Twoja sesja wygasła. Zaloguj się ponownie.</div>
        )}
        {error && <div className="auth-error">{error}</div>}

        <div className="form-group">
          <label className="form-label">E-mail</label>
          <input
            className="form-input"
            type="text"
            autoComplete="username"
            placeholder="np. jan.kowalski@firma.pl"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoFocus
          />
        </div>

        <div className="form-group">
          <label className="form-label">Hasło</label>
          <input
            className="form-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button className="btn btn-primary auth-btn" type="submit" disabled={loading}>
          {loading ? 'Logowanie...' : 'Zaloguj się'}
        </button>

        <p className="auth-footer">
          <Link to="/forgot-password">Nie pamiętam hasła</Link>
        </p>

        <p className="auth-note">
          Chcesz założyć konto? Skontaktuj się z nami:{' '}
          <a href="mailto:kontakt@maszynownik.pl">kontakt@maszynownik.pl</a>
        </p>
      </form>
    </div>
  );
};

export default Login;
